import LanguageModal from './language-modal';

export default LanguageModal;